module.exports = __webpack_public_path__ + "img/ring_skip_0_null_0@3x.8191f79b.png";